module.exports = __webpack_public_path__ + "img/aboutBorder.64dc5dfa.svg";